import {currencyFormat} from "@/mixins/currencyFormat";

export const mortgageOptions = {
    mixins: [currencyFormat],
    data() {
        return {
            reviewTypeOptions: [
                {
                    label: 'Sole Name',
                    value: 'single'
                },
                {
                    label: 'Joint Names',
                    value: 'mirror'
                }
            ],
            handoverOptions: [
                {
                    label: 'Handover Immediately',
                    value: true
                },
                {
                    label: 'Add Information',
                    value: false
                }
            ]
        }
    }
}
